const CAIframe = {
  init() {
    let lastIframeHeight = 0;
    let lastUrl = window.location.pathname;
    let hasLoaded = false;
    let hasSentLoginSignal = false;
    let originUrl = null;

    window.addEventListener('message', function (event) {
      originUrl = event.data.origin;
    });

    const setOriginUrl = setInterval(() => {
      if (originUrl && window.self !== window.top) {
        clearInterval(setOriginUrl);

        this.replaceAllLinks(originUrl);
        return;
      }
    }, 500);

    setInterval(() => {
      const editor = document.querySelector('.page-editor-draft');

      const height = Math.max(
        document.body.scrollHeight,
        document.body.offsetHeight,
        // document.documentElement.clientHeight,
        // document.documentElement.scrollHeight,
        document.documentElement.offsetHeight
      );

      const newUrl = window.location.pathname;

      if (!hasLoaded) {
        hasLoaded = true;
        window.parent.postMessage({ hasLoaded }, '*');
      }

      if (editor) {
        const isDraftEditor = true;
        window.parent.postMessage({ isDraftEditor }, '*');
      } else if (lastIframeHeight !== height) {
        lastIframeHeight = height;
        window.parent.postMessage({ height }, '*');
      }

      if (lastUrl !== newUrl) {
        lastUrl = newUrl;
        window.parent.postMessage({ lastUrl }, '*');
      }

      if (!hasSentLoginSignal && window.location.pathname === '/login') {
        hasSentLoginSignal = true;
        window.parent.postMessage({ login: true }, '*');
      }
    }, 150);

    this.hideElementsWhenInIframe();
  },

  hideElementsWhenInIframe() {
    if (window.self !== window.top) {
      document
        .querySelectorAll('.phpdebugbar')
        .forEach(el => (el.style.display = 'none'));
    }
  },

  replaceAllLinks(originUrl) {
    document.addEventListener('click', e => {
      const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
      const isWindows = navigator.platform.toUpperCase().indexOf('WIN') >= 0;

      if ((isMac && e.metaKey) || (isWindows && e.ctrlKey)) {
        e.preventDefault();
        const link = e.target.href.replace(window.location.origin, originUrl);
        window.open(link, '_blank');
      }
    });
  }
};

CAIframe.init();
